<template>
  <div class="device-box">
    <div class="device-name">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="name">
        <div><div class="name-color" :class="getClass(index)"></div> {{ getLabel(index) }}</div>
        <div>{{ getPercentage(index) }}</div>
      </div>
    </div>
    <div class="device-type">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="part"
        :class="[getClass(index), { 'rounded-left': index === 0, 'rounded-right': index === data.length - 1 }]"
        :style="{ width: getWidth(index) }"
        @mouseenter="handleMouseEnter(index)"
        @mouseleave="handleMouseLeave">
        <div v-if="activeIndex === index" class="tooltip">
          {{ getLabel(index) }}: {{ getPercentage(index) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeIndex: -1,
      labels: ['power', 'heat', 'other']
    }
  },
  methods: {
    getClass(index) {
      // 根据索引返回对应的类名
      const classes = ['power', 'heat', 'other'];
      return classes[index];
    },
    getWidth(index) {
      // 计算每部分的宽度比例
      const total = this.data.reduce((acc, item) => {
        return acc + Object.values(item)[0];
      }, 0);
      const value = Object.values(this.data[index])[0];
      const widthPercentage = (value / total) * 100;
      return `${widthPercentage}%`;
    },
    getLabel(index) {
      const labels = ['动力类', '发热类', '其他'];
      return labels[index];
    },
    getPercentage(index) {
      const total = this.data.reduce((acc, item) => {
        return acc + Object.values(item)[0];
      }, 0);
      const value = Object.values(this.data[index])[0];
      const percentage = (value / total) * 100;
      return `${percentage.toFixed(1)}%`;
    },
    handleMouseEnter(index) {
      this.activeIndex = index;
    },
    handleMouseLeave() {
      this.activeIndex = -1;
    }
  }
}
</script>

<style scoped lang="less">
@color-power: linear-gradient(270deg, #42CAF2 0%, #0D77F3 100%);
@color-heat: linear-gradient(270deg, #FFC06F 0%, #EF9735 100%);
@color-other: linear-gradient(270deg, #C1F373 0%, #2DCF39 100%);

.device-box {
  flex: 1;
  width: 100%;
  min-width: 0;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.device-name {
  width: 90%;
  min-width: 0;
  display: flex;
  padding: 0 30px;
  gap: 30px;
}

.name {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border-bottom: 1px solid #cccccc;
}

.name-color {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  display: inline-block;
}

.name-color.power {
  background: @color-power;
}

.name-color.heat {
  background: @color-heat;
}

.name-color.other {
  background: @color-other;
}

.device-type {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  height: 12px; // 设置轴的高度
  border-radius: 6px;
  margin-top: 20px;
}

.part {
  height: 100%;
  transition: transform 0.2s ease; // 添加过渡动画
  position: relative;
}

.part:hover {
  transform: scale(1.1); // 鼠标悬停时放大
  z-index: 10; // 确保放大后的部分在其他元素之上
}

.part.power {
  background: @color-power;
  box-shadow: 0 4px 14px 0 #C1DAFF;
}

.part.heat {
  background: @color-heat;
  box-shadow: 0 4px 14px 0 #FFE3C1;
}

.part.other {
  background: @color-other;
  box-shadow: 0 4px 14px 0 #C1FFD8;
}

.rounded-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.rounded-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.tooltip {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 20;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}
</style>
